export default "__VITE_ASSET__cda4545b__"